// extracted by mini-css-extract-plugin
module.exports = {"ZeroBills":"ZeroBills_ZeroBills__CnLF8"};